import i18next from 'i18next';

i18next.addResources('es', 'CheckoutForm', {
  subscriptionSuccessful: 'Su suscripción fue exitosa',
  thankYouForChoosingUbuntu: '¡Gracias por elegir Ubuntulaw!',
  confirm: 'Confirmar',
  paymentMethodChanged: 'Medio de pago actualizado con éxito',
  subscriptionChanged: 'Suscripción actualizada con éxito'
});
